import React from 'react';

/**
 * Small 12x12 chevron-arrow used inside the amber "pill" links on the
 * /research subpages (the "First appeared in MGMA Connection" /
 * "Companion to MGMA Connection" badges). Tightly sized to the 12px pill
 * type and animates a hover nudge via the parent's `group` hover.
 *
 * Default `className` reproduces the inline SVG it replaced byte-for-byte
 * (GEN-2342): `transition-transform duration-150 group-hover:translate-x-0.5`.
 * Consumers can override the className to retune sizing/animation.
 */
export function PillArrowIcon({
  className = 'transition-transform duration-150 group-hover:translate-x-0.5',
}: {
  className?: string;
}): React.ReactElement {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      aria-hidden="true"
      className={className}
    >
      <path
        d="M2 6h7M6 2l4 4-4 4"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
